import Entity from "./Entity";
import { useTheme } from "styled-components";
export default function (props) {
  const theme = useTheme();

  return <Entity {...props} theme={theme} />;
}
